import React, { useContext, useState } from 'react'
// import { ProductDetailContext } from '../../context/ProductDetail-context';
import './ProductDetails.css'
import { PRODUCTS } from '../../Products';
import { Link, useParams } from 'react-router-dom';
import { ShopContext } from '../../context/Shop-context';
import cyclebullet from '../../assets/products/cyclebullet.png'
// import { Slide } from 'react-slideshow-image';
// import { ReactPropTypes } from 'react';
import {ShoppingCart} from 'phosphor-react'
import RelatedProducts from './RelatedProducts';



export const ProductDetails = (props) => {
    const { id } = useParams();
    const {addToCart, removeFromCart, updateCartItemCount, cartItems} = useContext(ShopContext)
    var qty = cartItems[id];
    let Name =''
    let details =''
    let price, image, category, brand, color, weight, materials, frame, crank, videoSrc, otherDesc ;
    PRODUCTS.map((prodProp)=> {

        if (prodProp.id == id) {
            Name= prodProp.productName
            details= prodProp.materials
            image= prodProp.productImg
            price = prodProp.price
            category = prodProp.category
            brand = prodProp.brand
            color = prodProp.color
            weight = prodProp.weight
            materials = prodProp.materials
            frame = prodProp.frame
            crank = prodProp.crank
            videoSrc = prodProp.videoSrc
            otherDesc = prodProp.otherDesc
        }
        return ([Name, details])
    })
    console.log('Name',Name, price)
    function capitalize(str){
        try{
        return str[0].toUpperCase()+ str.substr(1,str.length-1)
    }
    finally{return str}
    }
      const [currentSlide, setCurrentSlide] = useState(0);
      const slides = [
        { type: 'image', url: image },
        { type: 'youtube', videoId: videoSrc },
      ];

      const nextSlide = () => {
        setCurrentSlide((prevSlide) => (prevSlide === slides.length - 1 ? 0 : prevSlide + 1));
      };

      const previousSlide = () => {
        setCurrentSlide((prevSlide) => (prevSlide === 0 ? slides.length - 1 : prevSlide - 1));
      };

    const [scroll, setScroll] = useState(false)
    const changeColor =()=>{
        window.scrollY >=98? setScroll(true): setScroll(false)
    }
    window.addEventListener("scroll", changeColor)

  return (
    <div id='ProductDetail'>
        <div id='details' className=''>
            <div id='left'>
                <div id='slideshow-container'>
                    <div id='all-left'>
                        <div className="slideshow">
                            <div id='prev-container'>
                                <button id='prev' onClick={previousSlide}>{'<'}</button>
                            </div>
                            {slides.map((slide, index) => {
                                if (index === currentSlide) {
                                if (slide.type === 'image') {
                                    return <img id='slide-media'
                                    // key={index}
                                    src={slide.url} alt={`Slide ${index}`} />;
                                } else if (slide.type === 'youtube') {
                                    return (
                                    <iframe id='slide-media'
                                        // width="560" 
                                        // height="315"
                                        key={index}
                                        title={`Slide ${index}`}
                                        src={videoSrc}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                    );
                                }
                                }
                                return null;
                            })}
                            <div id='next-container'>
                                <button id='next' onClick={nextSlide}>{'>'}</button>
                            </div>
                        </div>
                        <div id='add-subtract' className='flex items-center m-auto justify-between'>
                            <h2> Price:  {'\u20B9'}{price}</h2>
                            <div id='btns'>
                            <span>
                                { <button className='h-8 w-8 border border-gray-700' onClick={()=> {qty>0 && removeFromCart(id) }}> - </button>}
                                { <input id='manual' value={qty} className='w-8 border m-auto p-1 mx-1 text-center' placeholder='Qty' onChange={((e)=>updateCartItemCount(Number(e.target.value),id))} /> }
                                <button className='h-8 w-8 border border-gray-700 mr-8' onClick={()=>addToCart(id)}> + </button> </span>
                                <span id='cart-logo1'><Link to='/cart'>  <b> <ShoppingCart size={32}/> </b></Link></span>
                            </div>
                    </div>
                </div>
            </div>
        </div>


        <div id='mid'>
            <h1 id={scroll ? 'scrolled' : 'notScrolled'}> {Name}</h1>
            <h3> Details: </h3>
            <table>
                <tr>
                <td id='col1'> <b>Brand</b></td>
                <td id='col2'> {brand}</td>
                </tr>
                <tr>
                <td id='col1'> <b>Model</b></td>
                <td id='col2'> {Name}</td>
                </tr>
                <tr>
                <td id='col1'> <b>Color</b></td>
                <td id='col2'> {capitalize(color)}</td>
                </tr>
                <tr>
                <td id='col1'> <b>Weight</b></td>
                <td id='col2'> {weight} kg</td>
                </tr>
                <tr>
                <td id='col1'> <b>Materials</b></td>
                <td id='col2'> {capitalize(materials)}</td>
                </tr>
            </table>
            <br/>
            <hr/>
            <br/>
            <p> <b>About the product</b> </p>
            <ul>
                <li><span><img id='bullet' src={cyclebullet} alt=''/></span> <span>{otherDesc}</span></li>
                <li>{frame != null  && <div id='li'> <span><img id='bullet' src={cyclebullet} alt=''/></span> <span>{frame}</span> </div>}</li>
                <li>{crank != null  && <div id='li'> <span><img id='bullet' src={cyclebullet} alt=''/></span> <span>{crank}</span> </div>}</li>
            </ul>

            </div>
            <div id='right'>
            {/* <h2 id={scroll?'scrolled' : 'notScrolled'}><b>Related Products</b></h2> */}
            <h2 ><b>Related Products</b></h2>
            <div>
            <RelatedProducts id={id} category={category} brand={brand}/>
            </div>
                
            </div>
        </div>
    </div>

  )
}








// import React, { useState } from 'react';

// const Slideshow = () => {
//     const [currentSlide, setCurrentSlide] = useState(0);
//     const slides = [
//       { type: 'image', url: 'image1.jpg' },
//       { type: 'youtube', videoId: 'VIDEO_ID_1' },
//       { type: 'image', url: 'image2.jpg' },
//       { type: 'youtube', videoId: 'VIDEO_ID_2' },
//       // Add more slides as needed
//     ];
  
//     const nextSlide = () => {
//       setCurrentSlide((prevSlide) => (prevSlide === slides.length - 1 ? 0 : prevSlide + 1));
//     };
  
//     const previousSlide = () => {
//       setCurrentSlide((prevSlide) => (prevSlide === 0 ? slides.length - 1 : prevSlide - 1));
//     };
  
//     return (
//       <div>
//         <h1>Slideshow</h1>
//         <div className="slideshow">
//           {slides.map((slide, index) => {
//             if (index === currentSlide) {
//               if (slide.type === 'image') {
//                 return <img key={index} src={slide.url} alt={`Slide ${index}`} />;
//               } else if (slide.type === 'youtube') {
//                 return (
//                   <iframe
//                     key={index}
//                     title={`Slide ${index}`}
//                     width="560"
//                     height="315"
//                     src={`https://www.youtube.com/embed/${slide.videoId}`}
//                     frameBorder="0"
//                     allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen
//                   ></iframe>
//                 );
//               }
//             }
//             return null;
//           })}
//         </div>
//         <button onClick={previousSlide}>Previous</button>
//         <button onClick={nextSlide}>Next</button>
//       </div>
//     );
//   };
  
//   export default Slideshow;
  
  
  
//   // {PRODUCTS.map((prodProps) => {
  
//   //     console.log(prodProps.id == id && 55555)
//   // if (prodProps.id==id){
//   //     console.log("Hello")
//   //     return(
//   //     <div>
//   //         <h1>{prodProps.productName}
//   //         </h1>
//   //         <img src={prodProps.productImg} ></img>
  
//   //     </div>)
//   // }
//   // })}
//   // {/* <br/>Product: {productName} */}
//   // {/* Price: {price} {brand} {materials} */}